import React from 'react'
import './Home.css'
import Hero from '../Hero/Hero'
import Services from '../Services/Services'
import Process from '../Process/Process'
import Banner from '../Banner/Banner'
import OneClickSection from '../OneClickSection/OneClickSection'
import CircleFeature from '../CircleFeature/CircleFeature'
import SEOFeatures from '../SEOFeatures/SEOFeatures'
import FaqSection from '../FaqSection/FaqSection'
import Testimonials from '../Testimonials/Testimonials'

const Home = () => {
  return (
    <div>
      <Hero />
      <OneClickSection />
      <Testimonials />
      {/* <Services /> */}
      {/* <CircleFeature /> */}
      <Banner />
      <Process />
     
      <FaqSection />
       
    </div>
  )
}

export default Home
